import ROUTING_STATE_SHAPE from 'rlink-router/ROUTING_STATE_SHAPE';

export default function getContentMetaIndex (routing) {
  return ROUTING_STATE_SHAPE.getAt(routing, ['contentMetaIndex']);
}



// WEBPACK FOOTER //
// ./lib/rlink-router/getContentMetaIndex.js